import { uiStore } from "../uiStore"

export const useUIStore = () => {
  const isCollapsed = uiStore((state) => state.isCollapsed)
  const isMobileScreen = uiStore((state) => state.isMobileScreen)
  const setIsCollapsed = uiStore((state) => state.setIsCollapsed)
  const toggleCollapsed = uiStore((state) => state.toggleCollapsed)
  const setIsMobileScreen = uiStore((state) => state.setIsMobileScreen)
  const handleResize = uiStore((state) => state.handleResize)

  return {
    isCollapsed,
    isMobileScreen,
    setIsCollapsed,
    toggleCollapsed,
    setIsMobileScreen,
    handleResize,
  }
}

export default useUIStore
